import useAuth from '@hooks/useAuth';
import type { Config } from '@models/config';
import type { Scope } from '@models/scope';

export default function useFeatureFlagOrClaim(flag: keyof Config, scope: Scope | Scope[]): boolean | undefined {
  const { user, hasClaim } = useAuth();
  const hasFeatureClaim = hasClaim('feature/preview', scope);

  return !user ? undefined : !!config[flag] || hasFeatureClaim;
}
